import { Component } from 'react';
import styled from '@emotion/styled';

const Footer = styled.div`
  align-items: flex-end;
  display: flex;
  width: 100%;
  z-index: 1;
`;

const Tab = styled.a`
  border: 1px solid;
  color: #FFFFFF;
  cursor: pointer;
  display: inline-block;
  font-size: 1.556em;
  font-weight: 700;
  line-height: 1em;
  padding: 0.9em 0;
  position: relative;
  text-align: center;
  width: calc(100% / 3);
  text-decoration: none;

  @media (max-width: 600px) {
    font-size: 1.750em;
  }

  @media (max-width: 480px) {
    font-size: 1.429em;
    padding-bottom: 1.2em;
    padding-top: 1.2em;
  }

  &:before {
    color: #FFFFFF;
    content: "${props => props.content}";
    display: inline-block;
    font-family: Helvetica Neue;
    font-size: 3.5em;
    font-weight: 700;
    left: 50%;
    line-height: 1em;
    opacity: 0.1;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -53%);

    @media (max-width: 480px) {
      font-size: 4.25em;
    }
  }

  &:first-of-type {
    background-color: #CB1F70;
  }

  &:nth-of-type(2) {
    background-color: #56595D;
  }

  &:last-of-type {
    background-color: #898D94;
  }

  &.active {
    background-color: #DE222C;
    margin-top: -0.5em;
    padding-bottom: 1.1em;
    padding-top: 1.1em;

    @media (max-width: 480px) {
      margin-top: -0.4em;
      padding-bottom: 1.4em;
      padding-top: 1.4em;
    }
  }
`;

export default class TPRSFooter extends Component {
  includes(value) {
    for (var index = 0; i < this.length; i++) {
      if ( this[index] === value || ( this[index] !== this[index] && value !== value ) ) {
        return true;
      }
    }
    return false;
  }

  renderActiveClass(activePage, classArray) {
    return classArray.includes(activePage) ? "active" : null;
  }

  render() {
    const {
      activePage,
      clickEvent1,
      clickEvent2,
      clickEvent3
    } = this.props;

    return (
      <Footer>
        <Tab
          className={this.renderActiveClass(activePage, ["seal", "sealInner"])}
          content="1"
          onClick={clickEvent1}
          title="Seal"
          data-track="learn-more"
          data-track-element-location="tprs-footer"
          data-track-destination="seal-tab"
        >
          SEAL.
        </Tab>
        <Tab
          className={this.renderActiveClass(activePage, ["defend", "defendInner"])}
          content="2"
          onClick={clickEvent2}
          title="Defend"
          data-track="learn-more"
          data-track-element-location="tprs-footer"
          data-track-destination="defend-tab"
        >
          DEFEND.
        </Tab>
        <Tab
          className={this.renderActiveClass(activePage, ["breathe", "breatheInner"])}
          content="3"
          onClick={clickEvent3}
          title="Breathe"
          data-track="learn-more"
          data-track-element-location="tprs-footer"
          data-track-destination="breathe-tab"
        >
          BREATHE.
        </Tab>
      </Footer>
    );
  }
}
